import { useContext, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { AuthenticationContext } from "./Contexts";
import { useAPI } from "./services/api/API";

type RoleProtectedRouteProps = {
  children: ReactNode;
  /** At least one of these role names (JWT `employeeRoles`) must match. */
  allowedRoles: string[];
  redirectTo?: string;
};

/**
 * Requires login (like ProtectedRoute) and one of `allowedRoles`.
 */
export const RoleProtectedRoute = ({
  children,
  allowedRoles,
  redirectTo = "/home",
}: RoleProtectedRouteProps) => {
  const { token } = useContext(AuthenticationContext);
  const { checkRole } = useAPI();

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (!checkRole(allowedRoles)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};
